import React from 'react';

function Services() {
  return (
    <section className="tc-services-style2">
      <div className="container">
        <div className="row gx-0">
          <div className="col-12">
           
            <h2 className="fsz-45 fw-500 mb-50">
              AGI’s
              <span className="sub-font fst-italic color-orange1 fw-400">
                services
              </span>
            </h2>
           
            
            <div className="services">
              <div className="row">
                <div className="col-lg">
                  <a
                    href="/single_project"
                    className="service-card wow fadeInUp slow"
                    data-wow-delay="0.2s"
                  >
                    <div className="img">
                      <img
                        src="/home2/assets/img/services/ser1.webp"
                        alt=""
                        className="img-cover"
                      />
                      <div className="arrow">
                        <i className="fal fa-long-arrow-right ico-45"></i>
                      </div>
                    </div>
                    <div className="info pt-30">
                      <h4 className="fsz-24"> GLASS FACADE</h4>
                      <ul className="styled-points mt-4">
                        <li>Curtain Wall</li>
                        <li>Stick Glazing </li>
                        <li>Window Wall System</li>
                        <li>Slim Profile System</li>
                      </ul>
                                        
                    </div>
                  </a>
                </div>
                <div className="col-lg">
                  <a
                    href="/single_project3"
                    className="service-card wow fadeInUp slow"
                    data-wow-delay="0.4s"
                  >
                    <div className="img">
                      <img
                        src="/home2/assets/img/services/ser2.webp"
                        alt=""
                        className="img-cover"
                      />
                      <div className="arrow">
                        <i className="fal fa-long-arrow-right ico-45"></i>
                      </div>
                    </div>
                    <div className="info pt-30">
                      <h4 className="fsz-24"> FACADE SOLUTIONS </h4>
                      <ul className="styled-points mt-4">
                        <li>HPL </li>
                        <li>Zinc Composite</li>
                        <li>ACP</li>
                        <li>Copper Composite</li>
                        
                        <li>Louver</li>
                        
                      </ul>
                    </div>
                  </a>
                </div>
                <div className="col-lg">
                  <a
                    href="/single_project4"
                    className="service-card wow fadeInUp slow"
                    data-wow-delay="0.6s"
                  >
                    <div className="img">
                      <img
                        src="/home2/assets/img/services/ser3.webp"
                        alt=""
                        className="img-cover"
                      />
                      <div className="arrow">
                        <i className="fal fa-long-arrow-right ico-45"></i>
                      </div>
                    </div>
                    <div className="info pt-30">
                      <h4 className="fsz-24">ALUMINIUM WINDOWS & DOORS</h4>
                      <ul className="styled-points mt-4">
                        <li>Sliding & Casement Systems</li>
                        <li>Thermal Break Profiles</li>
                        <li>Acoustic & Weather Sealing</li>
                        <li>Custom Design & Fabrication</li>
                      </ul>
                    </div>
                  </a>
                </div>
                <div className="col-lg">
                  <a
                    href="/single_project6"
                    className="service-card wow fadeInUp slow"
                    data-wow-delay="0.6s"
                  >
                    <div className="img">
                      <img
                        src="\home2\assets\img\services\acoustic.webp"
                        alt=""
                        className="img-cover"
                      />
                      <div className="arrow">
                        <i className="fal fa-long-arrow-right ico-45"></i>
                      </div>
                    </div>
                    <div className="info pt-30">
                      <h4 className="fsz-24"> ACOUSTICS SOLUTION</h4>
                      <ul className="styled-points mt-4">
                        <li>Movable wall</li>
                        <li>Halspan Core</li>
                      </ul>
                    </div>
                  </a>
                </div>
                <div className="col-lg">
                  <a
                    href="/single_project5"
                    className="service-card wow fadeInUp slow"
                    data-wow-delay="0.6s"
                  >
                    <div className="img">
                      <img
                        src="\home2\assets\img\services\hardware.webp"
                        alt=""
                        className="img-cover"
                      />
                      <div className="arrow">
                        <i className="fal fa-long-arrow-right ico-45"></i>
                      </div>
                    </div>
                    <div className="info pt-30">
                      <h4 className="fsz-24">ARCHITECTURAL HARDWARE</h4>
                      <ul className="styled-points mt-4">
                        <li>Geze Hardware</li>
                        
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

        <div className="row  mt-70">
              
              {/* LEFT SIDE: "Our goal..." text */}
              <div className="col-lg-7">
                <h2 className="fsz-45 sub-font fw-500 js-splittext-lines">
                  Our goal is to create spaces that are not only beautiful, but also
                  <span className="color-orange1"> functional </span> and
                  <span className="color-orange1"> comfortable. </span>
                </h2>
                <div className="btns">
                  <a
                    href="/about"
                    className="butn borderd border rounded-pill mt-70 hover-bg-black me-2"
                  >
                    <span>
                      About Us
                      <i className="ms-2 fal fa-long-arrow-right ico-45"></i>
                    </span>
                  </a>
                  <a
                    href="/services"
                    className="butn rounded-pill mt-70 hover-bg-black bg-orange1 text-white"
                  >
                    <span>
                      View Full Services <i className="ms-2 fal "></i>
                    </span>
                  </a>
                </div>
              </div>

              {/* RIGHT SIDE: Phone box */}
              <div className="col-lg-4 offset-lg-1">
                <div className="phone-box" data-speed="1" data-lag="0.5">
                  <img
                    src="/home2/assets/img/subtract2.png"
                    alt=""
                    className="bg-img"
                  />
                  <h2 className="fsz-45 sub-font fw-400">T:+91 87545 05413</h2>
                  <p className="color-666 mt-40">
                    We’re just a call away!
                  </p>
                </div>
              </div>
  
        </div>

          
        </div>
        
      </div>
    </section>
  );
}

export default Services;
